import { render, staticRenderFns } from "./BigCamera.vue?vue&type=template&id=d49ca52c&scoped=true"
import script from "./BigCamera.vue?vue&type=script&lang=js"
export * from "./BigCamera.vue?vue&type=script&lang=js"
import style0 from "./BigCamera.vue?vue&type=style&index=0&id=d49ca52c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49ca52c",
  null
  
)

export default component.exports